<div class="cui-banner" *ngIf="isAuthenticated">
  CONTROLLED UNCLASSIFIED INFORMATION (CUI)
</div>
